/* 🤖 this file was generated by svg-to-ts */
export const mgcIconKnifeFilled: {
  name: 'knife-filled';
  data: string;
} = {
  name: 'knife-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.371 3.016c-.092.03-.245.101-.34.157-.094.056-3.585 3.518-7.78 7.714-6.115 6.119-7.623 7.648-7.686 7.793-.235.546-.059 1.194.412 1.518.295.203 1.166.454 2.159.622a12.351 12.351 0 0 0 9.432-2.262c.227-.17 1.236-.995 2.244-1.835 1.893-1.577 2.014-1.696 2.113-2.062.066-.245.028-.65-.084-.881-.07-.147-.365-.472-1.116-1.231l-1.021-1.031 2.365-2.369c2.143-2.146 2.377-2.393 2.486-2.625a1.513 1.513 0 0 0-.022-1.369c-.061-.112-.448-.531-.986-1.067-1.029-1.025-1.134-1.094-1.687-1.115a1.59 1.59 0 0 0-.489.043"/></svg>`
};
